export default {
  en: {
    title: 'Check your email',
    subtitle: 'Your password recovery instructions have been sent, please check your email',
  },
};
